// Eager slim slice of the chat function barrel (chat bundle-fold, 2026-08-01).
//
// Chat is no longer eager-merged as a whole context: MessengerOverlay mounts
// behind a `_chatCtxFolded` if-latch and the FULL chat context (components +
// functions) folds via the workspace shell's `ensureChatContext` (dynamic
// import + foldSharedLibContext) the first time any opener runs. The fold is
// add-missing, so it never double-registers what this slice already carries.
//
// ONLY the functions that non-chat surfaces reach BEFORE any fold stay here:
//   • subscribeRealtime — el.call'd by the shell root itself at boot
//     (workspace/app.js `_ensureShellRealtime`) so message/notification
//     toasts + the chime work on every route with chat never opened. Also
//     dynamic-imported by loadPrivateData's realtime wave (module-cached —
//     same instance either way).
//   • openChatFromToast — toast click actions carry
//     `{ call: 'openChatFromToast' }` (shared GlobalNotification), fired on
//     ANY route; it ensures the fold itself before opening the drawer.
//   • chatContextItems / personContextItems + their dispatches
//     (channelActions.js) — the workspace sidebar's channel-row "…" menu
//     (SidebarItemMore) builds items SYNCHRONOUSLY on right-click, pre-fold;
//     the dispatches ensure the fold before delegating to lazy actions
//     (openChannelSettings, messageUser, …).
//   • chatUtils — pure helpers the above import; also statically imported by
//     workspace loadPrivateData (people/channel priming), so it is in the
//     eager graph regardless.
// Every OTHER chat function (sendMessage, messageUser, createChannel,
// reactions, uploads, modals, search, …) registers at fold time; cross-route
// callers (aiWorkspaceOps, PersonPopover, AppSidebar, meet applySuggestion,
// pageContext deep-links) ensure the fold first.
//
// Chat's state.js ALSO rides the eager entry in sharedLibraries.js —
// `messages` + `_chatDrawerOpen` are declared ONLY there, and eager surfaces
// write `_chatDrawerOpen` on any route (v3.14 trips on undeclared root keys).
export * from './chatUtils.js'
export * from './channelActions.js'
export { subscribeRealtime } from './subscribeRealtime.js'
export { openChatFromToast } from './openChatFromToast.js'
// The AI-answer view's PROVIDER (functions/chatAnswer.js): the shell reads it
// on ANY route to know the chat view exists, before the chat context folds;
// the view itself folds it first (`fold: 'chat'`, workspace functions/
// assistantAppViews.js).
export { chatAiViews } from './chatAnswer.js'
